// extracted by mini-css-extract-plugin
export default {"editBlockButton":"EditBlockButton_editBlockButton__KxaIw","pulse":"EditBlockButton_pulse__weN5V"};